import { render, staticRenderFns } from "./selectQuotaList.vue?vue&type=template&id=5bfc3994&scoped=true&"
import script from "./selectQuotaList.vue?vue&type=script&lang=js&"
export * from "./selectQuotaList.vue?vue&type=script&lang=js&"
import style0 from "./selectQuotaList.vue?vue&type=style&index=0&id=5bfc3994&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc3994",
  null
  
)

export default component.exports